export default __webpack_public_path__ + "static/media/regeneroot.4cc60ebe.jpg";